import { connect } from 'react-redux';
import RoleBasedRoute from '../../../components/providers/RoleBasedRoute';
import { profile } from 'core/selectors';

export default connect(
  state => ({
    profile: profile(state),
  }),
  {},
)(RoleBasedRoute); 